module.exports = __webpack_public_path__ + "img/promotion-header.ce3525d2.png";